<template>
  <div class="device-box">
    <div class="left">
<!--      设备接入-->
      <div class="sbjr">
        <div class="device-top">
          <i class="iconfont icon-shebeijieru"></i>
          <span>设备接入</span>
        </div>
        <div class="sbjr-box">
          <el-form ref="sbjrForm" :model="sbjrForm" label-width="80px">
            <el-form-item label="硬件品牌">
              <el-select popper-class="form-select-dropdown" v-model="sbjrForm.type" placeholder="选择厂商" :popper-append-to-body="false" style="height: 40px">
                <el-option label="海康萤石云" :value="0"></el-option>
                <el-option label="大华云睿" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="序列号" v-if="sbjrForm.type === 0">
              <el-input placeholder="请输入序列号" style="width: 270px" v-model="sbjrForm.haiKangYs7.deviceSerial"></el-input>
            </el-form-item>
            <el-form-item label="验证码" v-if="sbjrForm.type === 0">
              <el-input placeholder="请输入验证码" style="width: 270px" v-model="sbjrForm.haiKangYs7.validateCode"></el-input>
            </el-form-item>
            <el-form-item label="序列号" v-if="sbjrForm.type === 1">
              <el-input placeholder="请输入序列号" style="width: 270px" v-model="sbjrForm.daHuaYunRui.deviceId"></el-input>
            </el-form-item>
            <el-form-item label="用户名" v-if="sbjrForm.type === 1">
              <el-input placeholder="请输入用户名" style="width: 270px" v-model="sbjrForm.daHuaYunRui.devUsername"></el-input>
            </el-form-item>
            <el-form-item label="密码" v-if="sbjrForm.type === 1">
              <el-input placeholder="请输入密码" style="width: 270px" v-model="sbjrForm.daHuaYunRui.devPassword"></el-input>
            </el-form-item>
            <el-form-item label="所在乡镇">
              <el-select popper-class="form-select-dropdown" v-model="sbjrForm.town" placeholder="所在乡镇" :popper-append-to-body="false" style="height: 40px">
                <el-option v-for="item in townshipList" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="jieru" @click="addDevice">
            <i class="el-icon-plus"></i>接入
          </div>
        </div>
      </div>
<!--      设备设置-->
      <div class="sbsz">
        <div class="device-top">
          <i class="iconfont icon-shebeishezhi"></i>
          <span>设备设置</span>
        </div>
        <div class="sbsz-box">
          <el-form inline ref="info" :model="info" label-width="80px">
<!--            <el-form-item label="设备编号">-->
<!--              <el-input disabled placeholder="请输入设备编号" style="width: 350px" v-model="info.id"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="设备名称">
              <el-input placeholder="请输入设备名称" style="width: 350px" v-model="info.deviceName"></el-input>
            </el-form-item>
            <el-form-item label="设备地点">
              <el-input placeholder="请输入设备地点" style="width: 350px" v-model="info.deviceLocation"></el-input>
            </el-form-item>
            <el-form-item label="经度">
              <el-input placeholder="请输入经度" style="width: 130px" v-model="info.longitude"></el-input>
            </el-form-item>
            <el-form-item label="纬度">
              <el-input placeholder="请输入纬度" style="width: 130px" v-model="info.latitude"></el-input>
            </el-form-item>
            <el-form-item label="安装高度">
              <el-input placeholder="请输入安装高度" style="width: 350px" v-model="info.height"></el-input>
            </el-form-item>
            <el-form-item label="点位图片">
              <el-upload
                class="avatar-uploader"
                action=""
                :on-change="upLoadImage"
                :show-file-list="false"
                accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                :auto-upload="false">
                <img v-if="info.image" :src="baserUrl + info.image" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="所在乡镇">
              <el-select popper-class="form-select-dropdown dropdown-150" v-model="info.town" placeholder="所在乡镇" :popper-append-to-body="false" style="width: 350px">
                <el-option v-for="item in townshipList" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="辅助定位">
              <el-select popper-class="form-select-dropdown" v-model="info.agps" placeholder="辅助定位" :popper-append-to-body="false" style="width: 350px">
                <el-option label="开启" :value="1"></el-option>
                <el-option label="不开启" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="confirm" @click="confirmEdit">确认</div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="device-top">
        <i class="iconfont icon-a-shexiangtou_huaban1"></i>
        <span>摄像头</span>
        <div class="search-box">
          <el-input placeholder="设备名称" style="width: 150px" v-model="formInline.deviceName" clearable></el-input>
          <el-select clearable popper-class="form-select-dropdown" v-model="formInline.town" placeholder="所在乡镇" :popper-append-to-body="false" style="width: 150px;margin-left: 10px">
            <el-option v-for="item in townshipList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
<!--          <el-input placeholder="设备序列号" style="width: 150px;margin-left: 10px" v-model="formInline.deviceSerial" clearable></el-input>-->
        </div>
        <div class="refresh" @click="getDeviceList">
          <i class="iconfont icon-shuaxin"></i>刷新
        </div>
      </div>
      <div class="right-box">
        <table class="table-box table-head" cellpadding="0" cellspacing="0">
          <tr ref="tableTr">
            <th class="label" v-for="item in headList" :key="item.label" :width="item.width">{{ item.label }}</th>
          </tr>
        </table>
        <div class="scroll-y" ref="scrollBox">
<!--          <AutoScroll :height="70" :step="30" :counts="5">-->
            <table class="table-content" cellpadding="0" cellspacing="0">
              <tr v-for="i in deviceList" :key="i.id" class="table-tr" @click="editDevice(i)">
                <td class="val" width="100">{{ i.deviceName }}</td>
                <td class="val" width="140">{{ i.deviceSerial }}</td>
                <td class="val" width="180">{{ i.deviceLocation }}</td>
                <td class="val" width="100">{{ i.town | filterTown }}</td>
                <td class="val" width="100">
                  <el-image
                    v-if="i.image"
                    style="width: 60px; height: 60px"
                    :src="baserUrl + i.image"
                    :preview-src-list="[baserUrl + i.image]"
                    fit="fill"></el-image>
                </td>
                <td class="val" width="80">{{ i.height }}</td>
                <td class="val" width="100">{{ (i.longitude || '') + ' ' + (i.latitude || '') }}</td>
                <td class="val" width="80" :class="'status' + i.status">{{ i.status === 0 ? '离线' : i.status === 1 ? '在线' : '升级中' }}</td>
              </tr>
            </table>
<!--          </AutoScroll>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addDevice, getDeviceList, editDevice } from "@/api/device";
import { townshipList } from "../../../../utils/common";
import { uploadFile } from "../../../../api/common";
import { baserUrl } from "../../../../plugins/BsaeUrl";

export default {
  name: "device",
  data () {
    return {
      baserUrl: baserUrl,
      sbjrForm: {
        town: '', // 所属乡镇
        type: 1, // 摄像头厂商：0-海康萤石云；1-大华云睿
        haiKangYs7: {
          deviceSerial: '', // 设备序列号
          validateCode: '' // 校验码
        }, // 海康入参
        daHuaYunRui: {
          deviceId: '', // 设备id
          deviceSerial: '',
          devUsername: '', // 设备用户名(使用Base64编码传入,默认为admin)
          devPassword: '' // 设备密码(使用Base64编码传入，默认为admin123)
        },
        deviceName: '', // 设备名称
        deviceLocation: '', // 设备地点
        longitude: '', // 经度
        latitude: '' // 纬度
      },
      headList: [
        { label: '设备名称', width: '100'},
        { label: '序列号', width: '140'},
        { label: '设备地点', width: '180'},
        { label: '所属乡镇', width: '100'},
        { label: '点位照片', width: '100'},
        { label: '安装高度', width: '100'},
        { label: '经纬度', width: '80'},
        { label: '设备状态', width: '80'}
      ],
      deviceList: [],
      info: {
        image: '',
        agps: ''
      },
      formInline: {
        deviceName: '',
        town: '',
        status: '',
        page: 1,
        limit: 999
      },
      townshipList: townshipList
    }
  },
  mounted() {
    this.getDeviceList()
  },
  methods: {
    addDevice () {
      let form = {}
      if (this.sbjrForm.type === 0) {
        if (!this.sbjrForm.haiKangYs7.deviceSerial) return this.$message.error('请输入序列号')
        if (!this.sbjrForm.haiKangYs7.validateCode) return this.$message.error('请输入验证码')
        form = {
          type: this.sbjrForm.type,
          town: this.sbjrForm.town,
          haiKangYs7: {
            deviceSerial: this.sbjrForm.haiKangYs7.deviceSerial,
            validateCode: this.sbjrForm.haiKangYs7.validateCode
          }
        }
      } else {
        if (!this.sbjrForm.daHuaYunRui.deviceId) return this.$message.error('请输入序列号')
        if (!this.sbjrForm.daHuaYunRui.devUsername) return this.$message.error('请输入用户名')
        if (!this.sbjrForm.daHuaYunRui.devPassword) return this.$message.error('请输入密码')
        form = {
          type: this.sbjrForm.type,
          town: this.sbjrForm.town,
          daHuaYunRui: {
            deviceId: this.sbjrForm.daHuaYunRui.deviceId,
            devUsername: this.sbjrForm.daHuaYunRui.devUsername,
            devPassword: this.sbjrForm.daHuaYunRui.devPassword
          }
        }
      }
      addDevice (form).then(() => {
        this.$message.success('添加成功')
        this.$bus.emit('editDevice', form)
        this.getDeviceList()
      })
    },
    getDeviceList () {
      getDeviceList(this.formInline).then(res => {
        this.deviceList = res.data.list
      })
    },
    editDevice (item) {
      this.info = JSON.parse(JSON.stringify(item))
    },
    upLoadImage (file){
      let formData = new FormData()
      formData.append("file", file.raw)
      uploadFile(formData).then(res => {
        this.$set(this.info, 'image', res.data)
        // this.info.image = res.data
        console.log(baserUrl + this.info.image)
      })
    },
    confirmEdit () {
      if (!this.info.id) {
        return this.$message.error('未选择编辑设备')
      }
      let form = JSON.parse(JSON.stringify(this.info))
      if (this.info.type === 0) {
        form.haiKangYs7 = {
          deviceSerial: form.deviceSerial
        }
      } else {
        form.daHuaYunRui = {
          deviceId: form.deviceSerial
        }
      }
      editDevice(form).then(() => {
        this.$message.success('操作成功！')
        this.getDeviceList()
        this.$bus.emit('editDevice', form)
      })
    }
  },
  filters: {
    filterTown (val) {
      const list = townshipList.filter(x => {
        return x.value === val
      })
      return list[0] ? list[0].label : '-'
    }
  }
}
</script>

<style scoped lang="less">
  .status1{
    color: #00FFF6;
  }
  .status0{
    color: #FF1C2F;
  }
  .device-box{
    padding-bottom: 20px;
    //height: 500px;
    display: grid;
    grid-template-columns: 500px 1fr;
    grid-column-gap: 30px;
    .device-top{
      font-size: 16px;
      display: flex;
      align-items: center;
      color: #00B2FF;
      font-weight: 500;
      height: 50px;
      i{
        font-size: 24px;
        margin-right: 7px;
      }
    }
    .sbjr{
      .sbjr-box{
        padding: 20px 0;
        width: 100%;
        height: 210px;
        border: 1px solid #00B2FF;
        box-shadow: 0 0 20px 20px inset #0f2d48;
        display: flex;
        .jieru{
          width: 225px;
          height: 56px;
          background-image: url("~@/assets/dp/jieru.png");
          background-size: 100% 100%;
          margin: auto 20px;
          font-size: 22px;
          line-height: 56px;
          text-align: center;
          color: #00B2FF;
          cursor: pointer;
        }
      }
    }
    .sbsz{
      .sbsz-box{
        padding-top: 10px;
        width: 100%;
        height: 440px;
        border: 1px solid #00B2FF;
        box-shadow: 0 0 20px 20px inset #0f2d48;
        position: relative;
        .confirm{
          width: 360px;
          height: 60px;
          background-image: url("~@/assets/dp/device-confirm.png");
          background-size: 100% 100%;
          position: absolute;
          left: 77px;
          color: #00B2FF;
          font-size: 22px;
          line-height: 60px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .right{
      .device-top{
        color: #00FFF6;
        position: relative;
        .refresh{
          width: 180px;
          height: 50px;
          background-image: url("~@/assets/dp/refresh.png");
          background-size: 100% 100%;
          text-align: center;
          line-height: 50px;
          position: absolute;
          right: 0;
          cursor: pointer;
          i{
            font-size: 16px;
          }
        }
        .search-box{
          display: flex;
          position: absolute;
          right: 190px;
        }
      }
      .right-box{
        height: 750px;
        border: 1px solid #00FFF6;
        box-shadow: 0 0 20px 20px inset #5ef3ee1a;
        .table-box, .table-content{
          width: 100%;
        }
        .scroll-y{
          height: calc(100% - 40px);
          width: 100%;
        }
        .table-head {
          height: 40px;
          text-align: left;
          background-color: rgba(0, 255, 246, 0.3);
          th {
            padding: 0 10px;
            color: #00FFF6;
            font-size: 18px;
          }
        }
        .table-content{
          width: 100%;
          table-layout: fixed;
          .table-tr:hover{
            background-color: rgba(51, 51, 51, 0.5);
          }
          tr{
            height: 40px;
          }
          tr:nth-child(even) {
            background-color: rgba(0, 255, 246, 0.1);
          }
          td{
            padding: 0 10px;
            font-size: 16px;
            cursor: pointer;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap;  // 默认不换行；
          }
        }
      }
    }
  }
  /deep/ .el-form-item{
    margin-bottom: 10px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px solid #00B2FF;
    border-radius: 5px;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  /deep/ .dropdown-150{
    height: 150px !important;
    .el-scrollbar{
      height: 100%;
      & ::-webkit-scrollbar{
        height: 1px !important;
      }
    }
  }
  /deep/ .el-input__inner{
    height: 35px;
  }
  /deep/ .el-form-item{
    margin-bottom: 5px;
  }
</style>
